import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import '../../Footer.css';

class DivElement extends Component {
    render() { 
        return (
            <div className="footer-inner-div">
                <img className="footer-icon-left" src={this.props.image} alt="Hello"/>
                <div className="footer-text-left-div">
                    {this.props.content}                
                </div>
            </div>
        );
    }
}
 
export default DivElement;